function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import { Alert, Skeleton, Button, Carousel, Image } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { GeoAltFill, PlayCircleFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MomentsView = function MomentsView(_ref) {
  var event = _ref.event;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    momentsList = _useState2[0],
    setMomentsList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedMoment = _useState8[0],
    setSelectedMoment = _useState8[1];
  var contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79'
  };
  useEffect(function () {
    axios.get("".concat(Common.baseApiUrl, "getmoments/").concat(event.id.toString())).then(function (response) {
      if (response.data.status == 200) {
        setMomentsList(response.data.moments);
      } else {
        setErrorMessage("Une erreur est survenue pendant le chargement");
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue pendant le chargement");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      fluid: true,
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              background: "#FAD792",
              padding: "10px",
              borderRadius: "6px"
            },
            children: momentsList.length > 0 && /*#__PURE__*/_jsx(Carousel, {
              autoplay: true,
              children: momentsList.map(function (m) {
                return /*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 5,
                      md: 5,
                      children: /*#__PURE__*/_jsx(Image, {
                        src: m.image_url,
                        className: "image-box"
                      })
                    }), /*#__PURE__*/_jsxs(Col, {
                      lg: 6,
                      md: 6,
                      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h3", {
                        style: {
                          color: "#EEE"
                        },
                        children: ["\" ", m.caption]
                      })]
                    })]
                  })
                });
              })
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
            children: momentsList.map(function (m) {
              return /*#__PURE__*/_jsxs(Col, {
                lg: 2,
                md: 3,
                sm: 4,
                xs: 6,
                children: [/*#__PURE__*/_jsx(Image, {
                  src: m.image_url,
                  className: "image-box"
                }), /*#__PURE__*/_jsxs("div", {
                  children: ["\" ", m.caption]
                })]
              }, "m" + m.id.toString());
            })
          })]
        })
      })
    })
  });
};
export default MomentsView;